import { ReactElement } from 'react';
import classNames from 'classnames';
import { Box, Stack, Text } from '@stitch-fix/mode-react';
import { BuyWhatYouLove } from './illustrations/BuyWhatYourLove';
import { GetStarted } from './illustrations/GetStarted';
import { IntroduceYourself } from './illustrations/IntroduceYourself';
import { LoveYourLook } from './illustrations/LoveYourLook';
import { SendBackTheRest } from './illustrations/SendBackTheRest';
import styles from './style.module.scss';
export type StepsWithIllustrationsProps = {
  title?: string;
  learnMore?: string;
  steps: {
    title: string;
    description: string;
    icon: IconKey;
  }[];
};
type IconKey = 'IntroduceYourself' | 'GetStarted' | 'BuyWhatYouLove' | 'SendBackTheRest' | 'LoveYourLook';
const icons: Record<IconKey, ReactElement> = {
  IntroduceYourself: <IntroduceYourself />,
  GetStarted: <GetStarted />,
  BuyWhatYouLove: <BuyWhatYouLove />,
  SendBackTheRest: <SendBackTheRest />,
  LoveYourLook: <LoveYourLook />
};
export const getIcon = (icon: IconKey) => icons[icon];
export const StepsWithIllustrations = ({
  title,
  learnMore,
  steps
}: StepsWithIllustrationsProps) => {
  return <Box style={{
    textAlign: 'center'
  }}>
      {title && <Box m="0 auto" p="34px">
          <Text as="h2" setting="title-medium">
            {title}
          </Text>
        </Box>}
      <Box as="ul" m={0} p={0}>
        {steps.map((step, index) => {
        const number = index + 1;
        const isEven = number % 2 === 0;
        return <li className={styles.step} key={step.title}>
              <Box className={styles.number}>
                <Text className={styles['number-icon']}>{`0${number}`}</Text>
              </Box>
              <Box className={classNames(styles['content-container'], {
            [styles['content-container__reverse-direction']]: isEven
          })}>
                {step.icon && <div className={classNames(styles.illustration, styles[`illustration-${number}`], {
              [styles['illustration__hidden-placeholder']]: isEven
            })}>
                    {getIcon(step.icon)}
                  </div>}
                <Stack>
                  <Box className={styles.content}>
                    <Text as="h3" family="medium" height="standard" scale="5" className={styles['step-title']} m="1.5rem auto 0.5rem">
                      <span className={styles['step-number']}>{`${number}. `}</span>
                      <span dangerouslySetInnerHTML={{
                    __html: step.title
                  }} />
                    </Text>
                    <Text mb={2} setting="body-medium-fixed" as="p" className={styles['learn-more']} dangerouslySetInnerHTML={{
                  __html: step.description
                }} />
                  </Box>
                </Stack>
                {step.icon && <div className={classNames(styles.illustration, styles[`illustration-${number}`], {
              [styles['illustration__hidden-placeholder']]: !isEven
            })}>
                    {getIcon(step.icon)}
                  </div>}
              </Box>
            </li>;
      })}
      </Box>
      {learnMore && <Text setting="body-medium-fixed" as="p" className={styles['learn-more']} dangerouslySetInnerHTML={{
      __html: learnMore
    }} />}
    </Box>;
};